// extracted by mini-css-extract-plugin
export default {"root":"NodeHeader_root__RMJF0","icon":"NodeHeader_icon__1Rrrj"};